import * as React from 'react';
import { Button, Dialog, Text } from '.';
import { Grid } from '@mui/material';

interface Props {
  id?: string;
  name: string;
  label?: string;
  type?: string;
  separator?: string;
  buttonCaption?: string;
  onLoad?: (data: any) => void;
  readOnly?: boolean;
  disableMargin?: boolean;
  error?: string;
  children?: React.ReactNode;
}

export const InputBulkUpload: React.FunctionComponent<Props> = (props) => {
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState('');
  const inputRef = React.useRef<any>();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => { 
    var currentFiles: any;
    var currentType: any;

    if (e.target.files?.length === 1) {
      currentFiles = e.target.files[0];
      currentType = currentFiles?.type?.split('/')[0];
      if (currentType !== 'text') {
        setError('Invalid file');
        return;
      }
      const reader = new FileReader();
      reader.readAsText(currentFiles);
      reader.onload = () => {
        props.onLoad?.(parseData(reader.result, props.separator)); 
        setOpen(!!props.children);
      }
    }
    else inputRef.current.value = null;

    setError('');
  }

  const parseData = (data: any, separator?: string) => {
    const result = [];
    const rows = data.split('\n');
    const header = rows[0].trim().split(separator || ',');
    for (let i = 1; i < rows.length; i++) {        
      if (!rows[i]) continue;
      var row: any = {}
      const currentRow = rows[i].split(',');
      for (let j = 0; j < header.length; j++) 
        row[header[j].trim()] = currentRow[j].trim();
      result.push(row);
    }
    return result;
  }

  return (
    <Grid id={props.id || props.name} mt={props.disableMargin? 0 : 2} mb={props.disableMargin? 0: 3}>
      <Text label={props.label && props.children? props.label : ''} size='small' color='text.secondary' marginBottom={1}/>
      
      <input ref={inputRef} hidden accept={'.' + (props.type || 'csv')} type='file' value='' onChange={onChange}/>
      <Button type='outlined' label={props.buttonCaption} startIcon='cloud_upload' readOnly={props.readOnly} onClick={() => inputRef.current.click()} />
      
      <Text label={props.error || error} size='small' color='red'/>
      
      <Dialog open={open} onClose={() => setOpen(false)}>{props.children}</Dialog>
    </Grid>
  )
}


